import { NavGroupingChangeQuizAreaComponent } from './../groups/nav/nav-grouping-change-quiz-area/nav-grouping-change-quiz-area.component';
import { NavGroupingQuizListComponent } from './../groups/nav/nav-grouping-quiz-list/nav-grouping-quiz-list.component';
import { NavGroupingStudentIndexComponent } from './../groups/nav/nav-grouping-student-index/nav-grouping-student-index.component';
import { SubscriptionGroupEditComponent } from './group/subscription-group-edit/subscription-group-edit.component';
import { SubscriptionGroupShowComponent } from './group/subscription-group-show/subscription-group-show.component';
import { SubscriptionGroupingEditComponent } from './group/subscription-grouping-edit/subscription-grouping-edit.component';
import { SubscriptionGroupingIndexComponent } from './group/subscription-grouping-index/subscription-grouping-index.component';
import { SubscriptionGroupingModifySubtopicComponent } from './group/subscription-grouping-modify-subtopic/subscription-grouping-modify-subtopic.component';
import { SubscriptionGroupingQuizAreaModifyComponent } from './group/subscription-grouping-quiz-area-modify/subscription-grouping-quiz-area-modify.component';
import { SubscriptionGroupingQuizListComponent } from './group/subscription-grouping-quiz-list/subscription-grouping-quiz-list.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { authInterceptorProviders } from './../_helpers/auth.interceptor';
import { SharedModule } from './../shared/shared.module';
import { StudentModule } from './../student/student.module';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GuardianHomeNewComponent } from './guardian-home-new/guardian-home-new.component';
import { GuardianHomeShowComponent } from './guardian-home-show/guardian-home-show.component';
import { GuardianHomeTourComponent } from './guardian-home-tour/guardian-home-tour.component';
import { GuardianMainAreaComponent } from './guardian-main-area/guardian-main-area.component';

import { GuardianGroupIndexComponent } from './group/guardian-group-index/guardian-group-index.component';
import { SubscriptionGroupingStudentIndexComponent } from './group/subscription-grouping-student-index/subscription-grouping-student-index.component';
import { SubscriptionGroupingStudentNewComponent } from './group/subscription-grouping-student-new/subscription-grouping-student-new.component';

import { SubscriptionGroupingQuizNewComponent } from './group/subscription-grouping-quiz-new/subscription-grouping-quiz-new.component';
import { SubscriptionGroupingQuizShowComponent } from './group/subscription-grouping-quiz-show/subscription-grouping-quiz-show.component';
import { SubscriptionGroupingShowComponent } from './group/subscription-grouping-show/subscription-grouping-show.component';




@NgModule({
  declarations: [
    GuardianMainAreaComponent,
    GuardianHomeShowComponent,

    GuardianHomeNewComponent,
    GuardianHomeTourComponent,
    GuardianGroupIndexComponent,
    SubscriptionGroupingStudentNewComponent,
    SubscriptionGroupingStudentIndexComponent,
    SubscriptionGroupingShowComponent,
    SubscriptionGroupingQuizShowComponent,
    SubscriptionGroupingQuizNewComponent,
    SubscriptionGroupingIndexComponent,
    SubscriptionGroupingEditComponent,

    SubscriptionGroupEditComponent,
    SubscriptionGroupShowComponent,

    NavGroupingQuizListComponent,
    NavGroupingChangeQuizAreaComponent,
    NavGroupingStudentIndexComponent,
    SubscriptionGroupingQuizListComponent,
    SubscriptionGroupingModifySubtopicComponent,
    SubscriptionGroupingQuizAreaModifyComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    StudentModule,
    SharedModule
  ],
  exports:[
    GuardianMainAreaComponent,
    GuardianHomeShowComponent

  ],
  providers:[authInterceptorProviders]
})
export class GuardianModule { }
